var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-826-945H616V79H-826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-825-15H617v94H-825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-3H70v70H-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M24.333 20.333A6.664 6.664 0 0031 13.667 6.665 6.665 0 0024.333 7a6.664 6.664 0 00-6.666 6.667 6.664 6.664 0 006.666 6.666zM9.333 17v-5H6v5H1v3.333h5v5h3.333v-5h5V17h-5zm15 6.667C19.883 23.667 11 25.9 11 30.333v3.334h26.667v-3.334c0-4.433-8.884-6.666-13.334-6.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.bb30c63c08da4f3b0b3e06d4063ccc0e.svg";
export { ForwardRef as ReactComponent };